import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {getAccountColor} from 'modules/store/accounts';
import {getVendorIcon} from 'modules/store/vendors';
import {TIMEOUT_STORE} from 'util/constants';

const
    transformEntitiesFn = json => {
        if (typeof json !== 'object') {
            throw new Error('transformEntitiesFn needs an object to transform');
        }

        const vendorCode = json.vendor && json.vendor.code,
            extra = {};

        if (vendorCode === 'AWS') {
            extra.accessKey = json.extra && json.extra.access_key;
        } else if (vendorCode === 'ORACLE') {
            extra.userOcid = json.extra && json.extra.user_ocid;
            extra.tenancyOcid = json.extra && json.extra.tenancy_ocid;
            extra.fingerprint = json.extra && json.extra.fingerprint;
        } else if (vendorCode === 'VCLOUD') {
            extra.username = json.extra && json.extra.username;
            extra.organization = json.extra && json.extra.organization;
            extra.host = json.extra && json.extra.host;
            extra.virtualDataCenter = json.extra && json.extra.virtual_data_center;
        } else if (vendorCode === 'AZURE_CSP') {
            extra.tenant = json.extra && json.extra.tenant;
            extra.clientId = json.extra && json.extra.client_id;
        } else if (vendorCode === 'ALICLOUD') {
            extra.accessKey = json.extra && json.extra.access_key;
        } else if (vendorCode === 'GCLOUD') {
            extra.serviceAccountFilename = json.extra && json.extra.service_account_filename;
        }

        return {
            id:              json.id,
            alias:           json.title || json.alias,
            serviceName:     json.service && json.service.name,
            slug:            json.service && json.service.slug,
            accountColor:    json.account && getAccountColor(json.account.id),
            accountName:     json.account && json.account.alias,
            accountId:       json.account && json.account.account_id,
            spogAccountId:   json.account && json.account.id,
            accountVendorId: json.account && json.account.vendor_account_id,
            vendorIcon:      json.vendor && getVendorIcon(json.vendor.code),
            vendorCode:      json.vendor && json.vendor.code,
            vendorName:      json.vendor && json.vendor.title,
            credentials:     extra
        };
    };

const exports = storeModuleFactory({
    name:             'securityCredentials',
    endpoint:         endpoints.securityCredentials.endpoint,
    instanceEndpoint: endpoints.securityCredentials.instanceEndpoint,
    timeout:          TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    extraActions:     [{
        method: 'create',
        action: 'createNewCredentials',
        url:    endpoints.securityCredentials.endpoint,
        start:  state => ({
            ...state,
            isCreating: true,
            error:      null
        }),
        success: state => ({
            ...state,
            isCreating:    false,
            didInvalidate: true,
            error:         null
        }),
        transform: item => item
    }, {
        method: 'update',
        action: 'updateCredentials',
        url:    endpoints.securityCredentials.instanceEndpoint,
        start:  state => ({
            ...state,
            isUpdating: true,
            error:      null
        }),
        success: state => ({
            ...state,
            isUpdating:    false,
            didInvalidate: true,
            error:         null
        }),
        transform: item => item
    }, {
        method: 'delete',
        action: 'deleteCredentials',
        url:    endpoints.securityCredentials.instanceEndpoint,
        start:  state => ({
            ...state,
            isDeleting: true,
            error:      null
        }),
        success: state => ({
            ...state,
            isDeleting:    false,
            didInvalidate: true,
            error:         null
        }),
        transform: item => item

    }]
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.createFetchParams = (pagination, sortBy, filters) => ({
    ...pagination,
    ...filters,
    ordering: sortBy
});

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/securityCredentials.js